<script>
import MyTable from '../../components/MyTable.vue';
import { reactive, onMounted, ref, inject } from 'vue'
import coachesRepository from "@/services/api/coachesRepository";
import AlunosModal from "@/views/treinadores/AlunosModal.vue";
import { useRouter } from 'vue-router'

export default {
  components: {
    MyTable,
    AlunosModal
  },
  setup () {
    const router = useRouter()
    const swal = inject('$swal')

    onMounted(() => {
      buscaTreinadores()
    })

    const state = reactive({
      treinadores: [],
      treinadorId: 0
    })

    const columns = ref([
      {
        label: '',
        field: 'name'
      },
      {
        label: 'Ações',
        field: 'actions'
      }
    ])

    function buscaTreinadores () {
      coachesRepository.TreinadoresGet().then(response => {
        if(response.data.success) {
          state.treinadores = response.data.data
        }
      }).catch(error => {
        console.error(error)
      })
    }

    let showAlunos = ref(false)

    function listarAlunos(treinadorId) {
      state.treinadorId = treinadorId
      showAlunos.value = true
    }

    function novoTreinador() {
      router.push({ name: 'TreinadorNovo' })
    }

    function deletarTreinador(treinadorId, nome) {
      swal({
        title: 'Confirmar exclusão',
        text: `Deseja realmente excluir o treinador "${nome}"?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          coachesRepository.TreinadorDelete(treinadorId).then(response => {
            if (response.data.success) {
              swal({
                icon: 'success',
                title: 'Excluído!',
                text: 'Treinador excluído com sucesso.'
              })
              buscaTreinadores()
            }
          }).catch(error => {
            console.error(error)
            swal({
              icon: 'error',
              title: 'Erro',
              text: 'Erro ao excluir treinador'
            })
          })
        }
      })
    }

    return {
      state,
      columns,
      showAlunos,
      listarAlunos,
      novoTreinador,
      deletarTreinador
    }
  }
}
</script>

<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h3 class="mb-0">Lista de treinadores</h3>
      <button class="btn btn-sm btn-success" @click="novoTreinador">
        <i class="material-icons me-1" style="font-size: 18px; vertical-align: middle;">add</i>
        Novo Treinador
      </button>
    </div>
    <alunos-modal
        :treinadorId="state.treinadorId"
        :show="showAlunos"
        v-show="showAlunos"
        @fechaModal="showAlunos = false"
    />
    <MyTable
        :data="state.treinadores"
        :columns="columns"
        :hideHeader="true"
        :itemsPerPage="12">
      <template v-slot:row="{ row }">
        <td class="text-sm pointer">
          <div>
            <h5>
              {{row.name}}
            </h5>
          </div>
          <div class="row small">
            <div class="col-12">
              <span class="text-danger">Cadastrado em:</span>
              {{$filters.datePtbr(row.created_at)}}
            </div>
            <div class="col-12 col-md-4">
              <span class="text-danger">CPF:</span> {{row.cpf}}
            </div>
            <div class="col-12 col-md-4">
              <span class="text-danger">Data Nasc.:</span> {{$filters.datePtbr(row.birth_date)}}
            </div>
            <div class="col-12 col-md-4">
              <span class="text-danger">Cidade/UF:</span> {{row.city}} / {{row.state}}
            </div>
            <div class="col-12 col-md-4">
              <span class="text-danger">Telefone:</span> {{row.phone}}
            </div>
            <div class="col-12 col-md-4">
              <span class="text-danger">E-mail:</span> {{row.email}}
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 text-center">
              <span class="btn btn-sm btn-success small" @click="listarAlunos(row.id)">
                Listar alunos
              </span>
            </div>
          </div>
        </td>
        <td class="text-sm align-content-center">
          <div class="float-end">
            <div>
              <router-link
                  class="w-100 pointer btn btn-outline-info btn-sm d-flex"
                  title="Detalhes"
                  :to="{ name: 'TreinadorDetalhe', params: { id: row.id } }"
              >
                <i class="material-icons me-1">info</i>
                Detalhes
              </router-link>
            </div>
            <div class="mt-2">
              <router-link
                  class="w-100 pointer btn btn-outline-warning btn-sm d-flex"
                  title="Editar"
                  :to="{ name: 'TreinadorEditar', params: { id: row.id } }"
              >
                <i class="material-icons me-1">edit</i>
                Editar
              </router-link>
            </div>
            <div class="mt-2">
              <span
                  class="w-100 pointer btn btn-outline-danger btn-sm d-flex"
                  title="Deletar"
                  @click="deletarTreinador(row.id, row.name)"
              >
                <i class="material-icons me-1">delete</i>
                Deletar
              </span>
            </div>
          </div>
        </td>
      </template>
    </MyTable>
  </div>
</template>

<style scoped>

</style>